import { NgModule } from '@angular/core';
import { MbscModule } from '@mobiscroll/angular';
import { CommonModule } from '@angular/common';
import { SummaryComponent } from './summary.component';
import { RouterModule, Routes } from '@angular/router';
import { DescriptionCardComponent } from './description-card/description-card.component';
import { SharedModule } from 'src/app/components/shared.module';
import { CareTeamComponent } from './care-team/care-team.component';
import { LatestUpdatesComponent } from './latest-updates/latest-updates.component';
import { PatientByStageComponent } from './patient-by-stage/patient-by-stage.component';
import { HoldPatientsComponent } from './hold-patients/hold-patients.component';

const routes: Routes = [
  {
    path: '',
    component: SummaryComponent
  }
];

@NgModule({
  declarations: [
    SummaryComponent,
    DescriptionCardComponent,
    CareTeamComponent,
    LatestUpdatesComponent,
    PatientByStageComponent,
    HoldPatientsComponent
  ],
  imports: [
    MbscModule,
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule
  ]
})
export class SummaryModule { }
